import { HorizontalFlex } from "@enxcs/dap-ui-stratos";
import { styled } from "styled-components";

export const MicrophoneVolumeContainer = styled(HorizontalFlex)`
  width: 100%;
`;
